<form [formGroup]="formGroup" pcgSubmitUrl="api/Clients/Client/SaveClient" (messageReceive)="saveClient($event)">
  <div class="row">
    <input type="hidden" formControlName="clientId" />
    <div class="col-md-6">
      <div class="row">
        <pcg-control-group class="col-md-8" label="Client Name">
          <input pcgControlRef class="form-control" type="text" formControlName="clientName" />
        </pcg-control-group>
      </div>
    </div>
    <div class="col-md-6">
      @if (id !== 0) {
        <label [for]="letterCodes" class="control-label for">Letter Codes</label>
      }
      <ng-content></ng-content>
      <div class="row">
        @if (id !== 0) {
          <ng-select
            [items]="letterCodes"
            bindLabel="text"
            bindValue="value"
            appendTo="body"
            addTagText="Create New"
            [addTag]="openLetterCodeDetails"
            formControlName="letterCodes"
            multiple="true"
            >
          </ng-select>
        }
      </div>
    </div>
    <pcg-fixed-buttons>
      <a class="btn btn-cancel btn-lg" routerLink="/clients">Back</a>
      @if (id !== 0) {
        <button type="submit" class="btn btn-save btn-lg">Save Changes</button>
      }
      @if (id === 0) {
        <button type="submit" class="btn btn-save btn-lg">Save</button>
      }
    </pcg-fixed-buttons>
  </div>
</form>
